const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/sessionStorage.ts';
import { LoginData as LoginDataKey } from 'App/defs/loginDefs';

interface LoginData {
    access_token: string;
    token_type: 'Bearer';
    expires_in: number;
    login_type: string;
    kisim: {
        expiresIn: string;
        workId: string;
        patnr: string;
        aufgebotWorkId: string;
        invitationCode: string;
    };
}

export const getLoginData = (): LoginData => {
    const raw = sessionStorage.getItem(LoginDataKey);
    if (!raw) throw new Error('LoginData not found in sessionStorage');
    return JSON.parse(raw) as LoginData;
};

export const getPatNrFromSession = (): string => {
    return getLoginData().kisim.patnr;
};
